export default __webpack_public_path__ + "static/media/clipplane.d47a480a.vert";